import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import ChiSiamo from "@/pages/ChiSiamo";
import Studio from "@/pages/Studio";
import Recensioni from "@/pages/Recensioni";
import Contatti from "@/pages/Contatti";

const TITLES = {
    "/": "Dr. Mario Massironi — Dentista a Concorezzo (MB) | Studio Dentistico",
    "/servizi": "Servizi — Studio Dentistico Dr. Mario Massironi",
    "/chi-siamo": "Chi Siamo — Studio Dentistico Dr. Mario Massironi",
    "/studio": "Lo Studio — Studio Dentistico Dr. Mario Massironi",
    "/recensioni": "Recensioni — Studio Dentistico Dr. Mario Massironi",
    "/contatti": "Contatti e Prenotazioni — Studio Dentistico Dr. Mario Massironi",
};

function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        document.title = TITLES[pathname] || TITLES["/"];
        if (hash) {
            const t = setTimeout(() => {
                const el = document.querySelector(hash);
                if (el && window.__lenis) {
                    window.__lenis.scrollTo(el, { offset: -90 });
                } else if (el) {
                    el.scrollIntoView();
                }
            }, 120);
            return () => clearTimeout(t);
        }
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App min-h-screen bg-white">
            <BrowserRouter>
                <ScrollManager />
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/servizi" element={<Servizi />} />
                        <Route path="/chi-siamo" element={<ChiSiamo />} />
                        <Route path="/studio" element={<Studio />} />
                        <Route path="/recensioni" element={<Recensioni />} />
                        <Route path="/contatti" element={<Contatti />} />
                    </Routes>
                </main>
                <Footer />
                <WhatsAppFloat />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
